import { render, staticRenderFns } from "./TrialCard.vue?vue&type=template&id=737c43c4"
import script from "./TrialCard.vue?vue&type=script&lang=js"
export * from "./TrialCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports